import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@pancakeswap/uikit/dist/theme'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Kanit', sans-serif;
  }
  body {
    background-color: ${({ theme }) => theme.colors.background};
    background: url("https://tokensimage.github.io/images/BSC/MuskSwap/bg.png") no-repeat center center;
    background-size: cover;
    background-attachment: fixed;

    img {
      height: auto;
      max-width: 100%;
    }
  }
`

export default GlobalStyle
